window.addEventListener('load', (event) => {
  if(window.location.pathname === "/cart") {
    const items = document.querySelectorAll(".list-view-item__title > a")
    const productHandle = JSON.parse(localStorage.getItem("giftbox-added-offers")).length>0 ? JSON.parse(localStorage.getItem("giftbox-added-offers"))[0].productHandle : null
      if(items.length && productHandle){
          for(let i=0; i<items.length; i++){
             const href = items[i].href
              if (href.includes(productHandle)){
                  const selectQtyInput = document.querySelectorAll(".cart__qty-input")[i]
                  selectQtyInput.value = 1
                  selectQtyInput.disabled= "disabled"
                  selectQtyInput.readonly= "readonly"
              }
          }
      }
  }
}); 